<template>
<div
  class="report-index"
  v-loading="loading"
>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">
        <i class="ti-align-left"></i> Definições do Relatório
      </h4>
    </div>
    <div class="card-content">
      <div class="row">
        <div class="col-xs-12">
          <label>Defina o marcador para separa as colunas do arquivo CSV</label>:
          <p-radio
            inline
            v-model="csvSeparator"
            label=";"
          >; (ponto e vírgula)
          </p-radio>
          <p-radio
            inline
            v-model="csvSeparator"
            label=","
          >, (vírgula)
          </p-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h3>Relatório de lâmpadas por usuário:</h3>
          <LampsUsersReport :csv-separator="csvSeparator" />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h3>Relatórios gerais </h3>
          <general-counter-report></general-counter-report>
        </div>
      </div>

      <h4>
        Filtrar: {{eventLabel}}
      </h4>

      <dashboard-form-filters
        @filter="handleFilter"
        :showTimeRange="true"
        :buttom-label="`Filtrar ${eventLabel}`"
      />

      <div class="row">
        <div class="col-xs-12"><p> Selecionar {{eventLabel}}</p></div>
        <div class="col-xs-12">
          <EventsOptions
            :multiple="eventChoice === 'many'"
            @eventSelected="onEventSelected($event)"
          ></EventsOptions>
          <p>
            <input
              type="checkbox"
              id="enable-partial-report"
              v-model="enablePartial"
            >
            <label for="enable-partial-report">Gerar relatório parcial</label>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <el-progress :percentage="progressPercentage"/>
        </div>
      </div>
      <div
        class="row"
        style="margin-top: 30px;"
      >
        <div class="col-xs-12 text-right">
          <lamps-report
            :event-selected="eventSelected"
            :all-events="allEvents"
            :csv-separator="csvSeparator"
            @progress="setProgress($event)"
          />

          <global-ranking-report
            :events="eventsChosen"
            :enable-partial="enablePartial"
            :csv-separator="csvSeparator"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3>Relatórios Simplificados </h3>
        </div>
      </div>

      <h4>
        Filtrar: {{eventLabel}}
      </h4>

      <dashboard-form-filters
        @filter="handleSimplifiedFilter"
        :showTimeRange="true"
        :buttom-label="`Filtrar ${eventLabel}`"
      />

      <div class="row">
        <div class="col-xs-12"><p> Selecionar {{eventLabel}}</p></div>
        <div class="col-xs-12">
          <EventsOptions
            :multiple="eventChoice === 'many'"
            @eventSelected="onEventSelected($event)"
          ></EventsOptions>

          <p>
            <input
              type="checkbox"
              id="enable-lgpd"
              v-model="enableLGPD"
            >
            <label for="enable-lgpd">Ofuscar nomes dos clientes</label>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <el-progress :percentage="progressPercentageSimplified"/>
        </div>
      </div>


      <div
        class="row"
        style="margin-top: 30px;"
      >
        <div class="col-xs-12 text-right">
          <lamps-report-simplified
            :event-selected="eventSelected"
            :all-events="allEvents"
            :csv-separator="csvSeparator"
            :enableLGPD="enableLGPD"
            @progress="setProgressSimplified($event)"
          />

          <global-ranking-report-simplified
            :events="eventsChosen"
            :csv-separator="csvSeparator"
            :enableLGPD="enableLGPD"
          />
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import LampsReport from './LampsReport'
import LampsReportSimplified from './LampsReportSimplified'
import EventsReport from './EventsReport'
import GlobalRankingReport from './GlobalRankingReport2'
import GlobalRankingReportSimplified from './GlobalRankingReportSimplified'
import GeneralCounterReport from './GeneralCounterReport'
import EventsOptions from 'src/components/EventsOptions'
import DashboardFormFilters from '../../components/Trg/Filters/DashboardFormFilters'
import {defineWhereObject, verifyEmptyTags} from '../../services/DashboardCounter'
import swal from 'sweetalert2'
import LampsUsersReport from './LampsUsersReport'

export default {
  name: 'report-index',

  components: {
    LampsReportSimplified,
    GlobalRankingReportSimplified,
    DashboardFormFilters,
    EventsReport,
    LampsReport,
    GlobalRankingReport,
    GeneralCounterReport,
    EventsOptions,
    LampsUsersReport
  },

  data () {
    return {
      eventsChosen: [],
      eventChoice: 'many',
      loading: false,
      allProject: false,
      csvSeparator: ';',
      eventSelected: '',
      total: 0,
      progress: 0,
      allEvents: false,
      enablePartial: false,
      enableLGPD: false
    }
  },

  computed: {
    ...mapGetters({formatedDate: 'formatedDate'}),
    ...mapGetters('events', {optionsById: 'optionsById', events: 'events'}),
    ...mapGetters('tags', {tagsSelected: 'selecteds'}),

    eventLabel () {
      return localStorage.getItem('eventLabel') || 'Ações'
    },

    eventsOptions () {
      return this.optionsById ? this.optionsById.filter(item => item.status === 2 || this.enablePartial) : []
    },

    progressPercentage () {
      if (this.total === 0) {
        return 0
      }
      return parseInt((this.progress / this.total) * 100)
    },

    progressPercentageSimplified () {
      if (this.total === 0) {
        return 0
      }
      return parseInt((this.progressSimplified / this.total) * 100)
    },

    isEventRanking () {
      return this.event && this.event.winnerChoiceMode === 'ranking'
    }
  },

  methods: {
    ...mapActions('events', {
      fetchEvents: 'fetchAll'
    }),
    ...mapActions('eventsSpecifications', {fetchSpecifications: 'fetchAll'}),

    handleFilter () {
      const whereTags = defineWhereObject(undefined, this.tagsSelected, 'tagsIds')
      console.log(whereTags, this.tagsSelected)
      swal({
        title: 'Aguarde',
        type: 'info',
        html: 'Executando o filtro',
        showConfirmButton: false,
        onBeforeOpen: async () => {
          swal.showLoading()

          await this.fetchSpecifications({
            where: {
              '$and': whereTags['$and']
            },
            limit: 99999
          }).then((specifications) => {
            let whereQuery = []
            if (!verifyEmptyTags(this.tagsSelected)) {
              whereQuery.push({
                '$or': specifications.map(item => Object.assign({
                  _id: item.eventId
                }))
              })
            }

            if (this.formatedDate && this.formatedDate.length === 2) {
              whereQuery.push({
                'startDate': {
                  '$gte': this.formatedDate[0]
                }
              })
              whereQuery.push(
                {
                  'endDate': {
                    '$lte': this.formatedDate[1]
                  }
                })
            }

            return whereQuery.length > 0 ? this.fetchEvents({
              where: {
                '$and': whereQuery
              },
              limit: 99999999
            }) : this.fetchEvents({
              limit: 99999999,
              sort: {field: 'createdAt', direction: 'desc'}
            })
          })

          setTimeout(() => {
            swal.close()
          }, 1000)
        }
      })
    },

    handleSimplifiedFilter () {
      const whereTags = defineWhereObject(undefined, this.tagsSelected, 'tagsIds')
      swal({
        title: 'Aguarde',
        type: 'info',
        html: 'Executando o filtro',
        showConfirmButton: false,
        onBeforeOpen: async () => {
          swal.showLoading()

          await this.fetchSpecifications({
            where: {
              '$and': whereTags['$and']
            },
            limit: 99999
          }).then((specifications) => {
            let whereQuery = []
            if (!verifyEmptyTags(this.tagsSelected)) {
              whereQuery.push({
                '$or': specifications.map(item => Object.assign({
                  _id: item.eventId
                }))
              })
            }

            if (this.formatedDate && this.formatedDate.length === 2) {
              whereQuery.push({
                'startDate': {
                  '$gte': this.formatedDate[0]
                }
              })
              whereQuery.push(
                {
                  'endDate': {
                    '$lte': this.formatedDate[1]
                  }
                })
            }

            return whereQuery.length > 0 ? this.fetchEvents({
              where: {
                '$and': whereQuery
              },
              limit: 99999999
            }) : this.fetchEvents({
              limit: 99999999
              // sort: {field: 'createdAt', direction: 'desc'}
            })
          })

          setTimeout(() => {
            swal.close()
          }, 1000)
        }
      })
    },

    onEventSelected (event) {
      this.eventSelected = event
      if (typeof event === 'string') {
        this.eventSelected = [event]
      }

      this.setEventChosen()
    },

    setEventChosen () {
      this.eventsChosen = this.events ? this.eventSelected.map(event => {
        return this.events.find(item => {
          return event === item._id
        })
      }).filter(item => item) : []
    },

    setProgress ({current, total}) {
      this.progress = current
      this.total = total
      if (this.progress < this.total) {
        this.loading = true
      } else {
        this.loading = false
      }
    },

    setProgressSimplified ({current, total}) {
      this.progressSimplified = current
      this.total = total
      if (this.progressSimplified < this.total) {
        this.loading = true
      } else {
        this.loading = false
      }
    }
  },
  mounted () {
    this.loading = false
    this.progress = 0
    this.progressSimplified = 0
    this.total = 0
    this.fetchEvents({limit: 9999999})
  }
}
</script>
<style scoped>
  .row {
    margin-top: 15px;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Reports/ReportsIndex.vue